import React from "react";
import { Dialog, DialogContent, Button, Grid, Typography } from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import { Close, ArrowBack } from "@mui/icons-material"; // Import ArrowBack icon
import ManualIcon from "../../../../assets/icon/Manual.svg";
import CSVIcon from "../../../../assets/icon/CSV.svg";
import GuardianImage from "../../../../assets/icon/Add_guardian.svg";
import InviteManual from "./InviteManual";
import UploadCSVModal from './InviteCSV';

const typeButton = {
    height: "170px",
    width: "160px",
    borderRadius: "20px",
    border: "2px solid #321b6d",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    '&:hover': {
        border: "2px solid #321b6d",
    }
}

const typeText = {
    marginTop: "20px",
    fontSize: "18px",
    color: "#321b6d",
    fontWeight: 600,
    marginLeft: "auto",
    marginRight: "auto",
    display: "table"
}

const InviteModal = ({ fromDashboard = false, showModal, setShowModal, groupCode, schoolName, getData }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [showManual, setShowManual] = React.useState(false);
    const [showCSV, setShowCSV] = React.useState(false);

    const onClose = () => {
        setShowManual(false);
        setShowCSV(false);
        setShowModal(false);
    };

    return (
      <Dialog
        open={showModal}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: { borderRadius: '15px', padding: '16px' },
        }}
      >
        {/* Close button */}
        <Button
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            minWidth: '0',
            padding: '5px',
          }}
        >
          <Close style={{ color: '#321b6d' }} />
        </Button>

        {/* Back button (visible only in manual view) */}
        {(showManual || showCSV) && (
          <Button
            onClick={() => {
              setShowManual(false);
              setShowCSV(false);
            }}
            sx={{
              position: 'absolute',
              top: '10px',
              left: '10px', // Position on the left for back navigation
              minWidth: '0',
              padding: '5px',
            }}
          >
            <ArrowBack style={{ color: '#321b6d' }} />
          </Button>
        )}

        {/* Dialog Content */}
        <DialogContent>
          {!showManual && !showCSV && (
            <Grid container direction="column" alignItems="center" spacing={3}>
              {/* Image */}
              <Grid item>
                <img
                  src={GuardianImage}
                  alt="Add Guardian"
                  style={{
                    width: isMobile ? '150px' : '200px',
                    height: 'auto',
                    marginBottom: '10px',
                  }}
                />
              </Grid>

              {/* Title */}
              <Grid item>
                <Typography
                  variant="h6"
                  align="center"
                  fontWeight="bold"
                  color="#321b6d"
                >
                  Add Guardian
                </Typography>
              </Grid>

              {/* Buttons */}
              <Grid
                item
                container
                justifyContent="center"
                spacing={2}
                sx={{
                  flexDirection: { xs: 'column', sm: 'row' }, // Stack on mobile, single row on larger screens
                  alignItems: { xs: 'center', sm: 'flex-start' }, // Center items on mobile
                }}
              >
                {/* Manual Button */}
                <Grid
                  item
                  xs={12}
                  sm="auto"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    variant="outlined"
                    sx={typeButton}
                    onClick={() => setShowManual(true)}
                  >
                    <img
                      src={ManualIcon}
                      alt="Manual"
                      style={{ marginBottom: '8px' }}
                    />
                  </Button>
                  <Typography sx={typeText}>Manual</Typography>
                </Grid>

                {/* "or" Text */}
                <Grid
                  item
                  xs={12}
                  sm="auto"
                  sx={{
                    textAlign: 'center',
                    marginTop: { xs: '0px', sm: '65px' },
                  }}
                >
                  <Typography
                    align="center"
                    sx={{ fontWeight: 600 }}
                    color="#321b6d"
                  >
                    or
                  </Typography>
                </Grid>

                {/* Bulk Button */}
                <Grid
                  item
                  xs={12}
                  sm="auto"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    variant="outlined"
                    sx={typeButton}
                    onClick={() => setShowCSV(true)}
                  >
                    <img
                      src={CSVIcon}
                      alt="Bulk"
                      style={{ marginBottom: '8px' }}
                    />
                  </Button>
                  <Typography sx={typeText}>Bulk</Typography>
                </Grid>
              </Grid>
            </Grid>
          )}
          {showManual && (
            <InviteManual
              groupCode={groupCode}
              schoolName={schoolName}
              handleClose={onClose}
              getData={getData}
              fromDashboard={fromDashboard}
            />
          )}
          {showCSV && <UploadCSVModal handleClose={onClose} />}
        </DialogContent>
      </Dialog>
    );
};

export default InviteModal;
